import { Pressable } from "react-native";

import {
  Box,
  Text,
  VStack,
  IconProps,
} from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

type TabBarItemProps = {
  label: string;
  icon: (props: IconProps) => React.JSX.Element;
  onPress?: () => void;
  selected: boolean;
  bgOverride?: WhooshThemeColors;
  tintColorOverride?: WhooshThemeColors;
  routeName?: string;
};

export const TabBarItem = ({
  label,
  icon,
  onPress,
  selected,
  bgOverride,
  tintColorOverride,
  routeName,
}: TabBarItemProps) => {
  const tintColor = tintColorOverride ? tintColorOverride : "grayscale-1000";
  const iconColor = tintColorOverride ? tintColorOverride : "grayscale-1000";

  const bgColor = bgOverride
    ? bgOverride
    : selected
    ? "grayscale-100"
    : "surface-primary";

  const handlePress = () => {
    if (onPress) {
      onPress();
    }
  };

  return (
    <Pressable
      onPress={handlePress}
      testID={routeName ? `tab-bar-item-${routeName}` : undefined}
      accessibilityRole="tab"
      accessibilityLabel={label}
      accessibilityState={{ selected }}
    >
      <Box
        borderRadius="4"
        px={1}
        pb={3}
        pt={4}
        bg={bgColor}
        alignItems="center"
        justifyContent="center"
        minWidth={64}
        width={"auto"}
      >
        <VStack flex={1} alignItems="center" justifyContent="center" gap={1}>
          {icon({ color: iconColor, fill: "none" })}
          <Text color={tintColor} variant="mainTiny" mb={0}>
            {label}
          </Text>
        </VStack>
      </Box>
    </Pressable>
  );
};
